<!-- 现场处理服务表单---小程序自检信息 -->
<template>
    <layui-collapse ref="collapse" class="requestForm">
        <div class="layui-colla-item">
            <h2 class="layui-colla-title">现场处理服务信息</h2>
            <div class="layui-colla-content layui-show">
                <div class="layui-form-item-two layui-form-column" v-if="editRow.WORK_ORDER_CATEGORY == '1'">
                    <div class="layui-form-colun-inner">
                      <div class="layui-form-item-left">
                          <div class="layui-form-item">
                              <label class="layui-form-label">处理过程：</label>
                              <label class="layui-form-label right textarea">{{editRow.CHECK_DESC}}</label>
                          </div>
                              <div class="layui-form-item">
                              <label class="layui-form-label">处理结果：</label>
                              <label class="layui-form-label right textarea">{{editRow.CHECK_RESULT}}</label>
                          </div>
                          <div class="layui-form-item">
                              <label class="layui-form-label">备注：</label>
                              <label class="layui-form-label right textarea">{{editRow.CHECK_REMARKS}}</label>
                          </div>
                      </div>
                      <div class="layui-form-item-right">
                          <div class="layui-form-item">
                              <label class="layui-form-label">分配时间：</label>
                              <label class="layui-form-label right">{{editRow.CHECK_DESC ? editRow.YW_SERVICE_ORDER_CREATE_TIME : ''}}</label>
                          </div>
                          <div class="layui-form-item">
                              <label class="layui-form-label">接单时间：</label>
                              <label class="layui-form-label right">{{editRow.ORDER_TAKING_TIME}}</label>
                          </div>
                          <div class="layui-form-item">
                              <label class="layui-form-label">预约时间：</label>
                              <label class="layui-form-label right">{{editRow.APPOINT_TIME}}</label>
                          </div>
                          <div class="layui-form-item">
                              <label class="layui-form-label">到达时间：</label>
                              <label class="layui-form-label right">{{editRow.SIGNIN_TIME}}</label>
                          </div>
                          <div class="layui-form-item">
                              <label class="layui-form-label">提交时间：</label>
                              <label class="layui-form-label right">{{editRow.CHECK_TIME}}</label>
                          </div>
                      </div>
                    </div>
                    <div class="layui-form-bottom">
                      <label class="layui-form-label">附件：</label>
                      <div class="layui-input-inline" style="width:80%">
                          <layui-listfileupload v-model="editRow.CHECK_FILE_FS" :enabled="false" targetEl=".requestForm">
                          </layui-listfileupload>
                      </div>
                    </div>
                </div>
                <!-- 工程单，存在多个自检记录，用table的形式展示 -->
                <div class="layui-form-item-one" v-if="editRow.WORK_ORDER_CATEGORY == '2'">
                    <div class="layui-colla-content layui-show inside-table">
                        <layui-table
                            ref="selfCheckTable"
                            table-name="YW_SERVICE_ORDER_STATUS"
                            :lazy="true"
                            :defaultCondition="{}"
                            :page-size="5"
                            :page-range="2"
                            :page-options="[5,10, 20, 50, 100]"
                            :skin="'line'"
                            :height="height"
                            :sort="['CHECK_TIME:DESC']"
                            :renderRow="renderRow"
                            @table-event-preview="preview($event.data)"
                            >
                            <div>
                                <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                                <layui-tableconfig :config = "selfCheckTableList"></layui-tableconfig>
                                <div rowspan="3" align="left" fixed="right" title="操作" width="100">
                                    <script type="text/html" v-pre>
                                        <a class="layui-btn-xs" lay-event="preview">附件预览</a>
                                    </script>
                                </div>
                            </div>
                        </layui-table>
                    </div>
                </div>
            </div>
        </div>
        <div id ='signInOut_Form' class="layui-colla-item" v-show="dialogVisible">
          <div class="layui-form-item">
              <!-- <label class="layui-form-label">附件：</label> -->
              <div class="layui-input-inline"   style="width:98%;padding:0 16px">
                    <layui-listfileupload v-model="requestFormModel" :enabled="false"  targetEl=".requestForm"></layui-listfileupload>
              </div>
          </div>
        </div>
    </layui-collapse>
</template>
<script>
    export default {
        props: {
            editRow: {
                default: () => ({}),
                type: Object
            },
            height: { type: String, default: '280' }
        },
        data () {
            return {
                selfCheckTableList:[
                  { field: 'FLOW_NODE_ID_DESC', title: '节点名称', width: 300},
                  { field: 'CHECK_DESC', title: '处理过程', width: 300},
                  { field: 'CHECK_RESULT', title: '处理结果', width: 200},
                  { field: 'CHECK_REMARKS', title: '备注', width: 300},
                  { field: 'YW_SERVICE_ORDER_CREATE_TIME', title: '分配时间' , width: 180},
                  { field: 'ORDER_TAKING_TIME', title: '接单时间' , width: 180},
                  { field: 'APPOINT_TIME', title: '预约时间' , width: 180},
                  { field: 'SIGNIN_TIME', title: '到达时间' , width: 180},
                  { field: 'CHECK_TIME', title: '提交时间' , width: 180},
                ],
                requestFormModel : '',
                dialogVisible: false
            }
        },
        mounted () {
             this.$nextTick(()=> {
                if(Object.keys(this.editRow).length > 0){
                    if(this.editRow.WORK_ORDER_CATEGORY == '2'){
                        this.$refs.selfCheckTable.defaultCondition.SERVICE_ORDER_ID = this.editRow.SERVICE_ORDER_ID;
                        this.$refs.selfCheckTable.load();
                    }
                }
             });
        },
        methods: {
            //附件预览
            preview(row){
              if(row.CHECK_FILE_FS == ''){
                this.layer.openAlert('未找到附件！');
              }else {
                this.requestFormModel = row.CHECK_FILE_FS;
                this.dialogVisible = true;
                let popObj={popId: 'signInOut_Form',title: '附件预览',width:($(".layui-body").width() * 0.7),height: ($(".layui-body").height() * 0.6),targetEl: $('.requestForm')};
                this.layer.openConfigPop(popObj)
              }
            },
            
            renderRow(data){
                data.YW_SERVICE_ORDER_CREATE_TIME = this.editRow.YW_SERVICE_ORDER_CREATE_TIME;
                data.ORDER_TAKING_TIME = this.editRow.ORDER_TAKING_TIME;
                data.APPOINT_TIME = this.editRow.APPOINT_TIME;
                data.SIGNIN_TIME = this.editRow.SIGNIN_TIME;
            }
        }
    }
</script>
<style scoped>
  .inside-table >>> .layui-form{
      padding: 0 !important;
  }
  .core .layui-layer-wrap{
    min-height:300px!important
  }
</style>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/selfCheckForm.vue